

































import BaseFormEdit from "../../models/base.form.edit";
import { Component } from "vue-property-decorator";
import axios from "axios";
import moment from 'moment';

@Component({})
export default class Edit extends BaseFormEdit {
  form =  { servicesSelect: [], services: [], serviceId: "", note:``} as any;
  created() {            
      this.parentValidator.extend("isCodeUnique", this.isCodeUnique);      
  }
  get serviceName() {            
        return this.getService().name;        
    }

    get serviceSection() {        
        return  this.getService().section;       
    }

    get createDate() {
        return moment(String(this.form.createDate)).format("DD.MM.YYYY HH:mm");
    }
    
    getService() {
        return this.form.services.find((x:any) => x.id === this.form.serviceId) || { section: "", name: ""};        
    }       

    isCodeUnique = {
      validate(value: any, args: any) {        
        return axios
          .get("/Actions/ValidateCode?code=" + value + "&id=" + args[0])
          .then(response => {
            return response.data;
          })
          .catch(() => {});
      } 
    }
}
